import {BrokerageEstimationService} from "./services/BrokerageEstimationService";

const ModuleName = "tfApp.brokerage";

export default angular.module(ModuleName, [])
                      .service(BrokerageEstimationService.id, BrokerageEstimationService)
                      .name;
